import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { Button, createForm, Flex, RadioGroup, Text } from '@applyboard/crystal-ui';
import { useOnboardingFormControllerContext } from "../../../controller/OnboardingFormController";
import { storeBudgetValue, getStoredBudget, deleteStoredBudget } from "../../storage/Budget/localStorage";
import { LoadingOverlay } from "../../../../ab-common-legacy/LoadingOverlay";
import { useEditStudentPreferences, useStudentPreferences, useDeleteStudentPreferences } from "../../../../data";
import { BUDGET_OPTIONS } from "./consts";
import { useFormState } from "../../../FormStateProvider";
import { Layout } from "../../Layout";
import { PreferencesContainer } from "../../Layout/PreferencesContainer";
import { useAppContext } from "../../../CEF/Providers";
var _createForm = createForm(),
  Field = _createForm.Field,
  Form = _createForm.Form;
export var BudgetPage = function BudgetPage() {
  var _studentPreferences$b;
  var _useAppContext = useAppContext(),
    userId = _useAppContext.userId;
  var _useOnboardingFormCon = useOnboardingFormControllerContext(),
    handlePassed = _useOnboardingFormCon.handlePassed,
    handleSkipped = _useOnboardingFormCon.handleSkipped,
    handleError = _useOnboardingFormCon.handleError;
  var _useFormState = useFormState(),
    onShowError = _useFormState.onShowError;
  var _useStudentPreference = useStudentPreferences(userId, {
      enabled: Boolean(userId)
    }),
    studentPreferences = _useStudentPreference.studentPreferences,
    isLoadingStudentPreferences = _useStudentPreference.isLoadingStudentPreferences;
  var _useEditStudentPrefer = useEditStudentPreferences(userId, 'budget'),
    editStudentPreferences = _useEditStudentPrefer.editStudentPreferences;
  var _useDeleteStudentPref = useDeleteStudentPreferences(userId, 'budget'),
    deleteStudentPreferences = _useDeleteStudentPref.deleteStudentPreferences;
  if (isLoadingStudentPreferences) {
    return /*#__PURE__*/React.createElement(LoadingOverlay, {
      "aria-label": "Loading"
    });
  }
  var signedInSubmit = function signedInSubmit(budget) {
    if (budget) {
      var data = {
        values: Number(budget)
      };
      editStudentPreferences(data, {
        onSuccess: function onSuccess() {
          handlePassed();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handlePassed();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    }
  };
  var skipBudgetSubmit = function skipBudgetSubmit() {
    if (userId) {
      deleteStudentPreferences(undefined, {
        onSuccess: function onSuccess() {
          handleSkipped();
        },
        onError: function onError() {
          onShowError();
          handleError();
        }
      });
    } else {
      deleteStoredBudget();
      handleSkipped();
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: function onSubmit(data) {
      var budget = data.budget;
      if (userId) {
        signedInSubmit(budget);
      } else {
        storeBudgetValue([budget]);
        handlePassed();
      }
    },
    defaultValues: {
      budget: userId ? (_studentPreferences$b = studentPreferences.budget) !== null && _studentPreferences$b !== void 0 ? _studentPreferences$b : '' : getStoredBudget()
    },
    onError: handleError
  }, /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(PreferencesContainer, {
    skipButton: /*#__PURE__*/React.createElement(Button, {
      emphasis: "highlighted",
      intent: "secondary",
      size: "lg",
      onClick: skipBudgetSubmit,
      width: "fill",
      type: "button"
    }, "Skip"),
    submitButton: /*#__PURE__*/React.createElement(Button, {
      emphasis: "contained",
      intent: "primary",
      size: "lg",
      width: "fill",
      type: "submit"
    }, "Next")
  }, /*#__PURE__*/React.createElement(Field, {
    as: RadioGroup,
    name: "budget",
    label: /*#__PURE__*/React.createElement(Text, {
      variant: "titleL"
    }, "What's your estimated yearly tuition budget?"),
    required: false
  }, /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: 1
  }, BUDGET_OPTIONS.map(function (option) {
    return /*#__PURE__*/React.createElement(RadioGroup.Option, {
      key: option.value,
      label: option.label,
      value: option.value
    });
  }))))));
};